import "./CellarClub.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ChooseYourPath from "./sections/ChooseYourPath";
import SignatureDrinks from "./sections/SignatureDrinks";
import EnrollmentInquiry from "./sections/EnrollmentInquiry";
import Footer from "@/reusable_sections/Footer";
export default function CellarClubPage() {
  return <div>
      <MainNavigation />
      <ChooseYourPath />
      <SignatureDrinks />
      <EnrollmentInquiry />
      <Footer />
    </div>;
}